import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import IndexNavbar from "../../components/Navbars/IndexNavbar";
import Footer from "../../components/Footers/IndexFooter";

const ContactsPage = () => {
  const operator = {
    fullName: "Недугов Герман Владимирович",
    address: "г. Самара, Арцыбушевская улица, 171",
    email: "kaf_sud@samsmu.ru",
    phone: "+7 846 374-10-04 доб. 4450",
  };

  return (
    <>
      <IndexNavbar />
      <main className="section section-lg pt-7">
        <Container className="mt-5 mb-5">
          <Row className="justify-content-center">
            <Col lg="8">
              <Card className="shadow border-0">
                <CardBody className="p-5">
                  <h1 className="mb-4">Контакты</h1>
                  <p className="text-muted">
                    Для официальных обращений, запросов по персональным данным, отзывов согласия и вопросов о
                    конфиденциальности используйте следующие данные:
                  </p>

                  <ul className="list-group list-group-flush mb-4">
                    <li className="list-group-item"><strong>ФИО:</strong> {operator.fullName}</li>
                    <li className="list-group-item"><strong>Адрес:</strong> {operator.address}</li>
                    <li className="list-group-item"><strong>Email:</strong> {operator.email}</li>
                    <li className="list-group-item"><strong>Телефон:</strong> {operator.phone}</li>
                  </ul>

                  <div className="mb-4">
                    <h5 className="mb-3">Профили и научные ссылки</h5>
                    <ul className="list-unstyled mb-0">
                      <li className="mb-2">
                        <strong>ORCID:</strong>{" "}
                        <a href="https://orcid.org/0000-0002-7380-3766" target="_blank" rel="noreferrer">
                          https://orcid.org/0000-0002-7380-3766
                        </a>
                      </li>
                      <li className="mb-2">
                        <strong>Scopus Author ID:</strong>{" "}
                        <a href="http://www.scopus.com/inward/authorDetails.url?authorID=25947646500&partnerID=MN8TOARS" target="_blank" rel="noreferrer">
                          25947646500
                        </a>
                      </li>
                      <li className="mb-2">
                        <strong>РИНЦ:</strong>{" "}
                        <a href="https://elibrary.ru/author_items.asp?authorid=528216" target="_blank" rel="noreferrer">
                          https://elibrary.ru/author_items.asp?authorid=528216
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div className="mb-4">
                    <h5 className="mb-3">Вопросы по работе калькуляторов</h5>
                    <p className="mb-0 text-muted">
                      Если у вас возникли вопросы по корректности расчетов, алгоритмам работы калькуляторов,
                      техническим ошибкам или необходимости уточнения используемых методик, пожалуйста,
                      направляйте обращение по электронной почте или телефону, указанным выше.
                    </p>
                  </div>

                  <p className="mb-0">
                    Политика конфиденциальности: <Link to="/privacy">Политика конфиденциальности</Link>
                  </p>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default ContactsPage;
